var heading_default = {
  "fontElementMap": "sdyvB",
  "elementSpacing": "oQuL8",
  "headerOne": "fsEaY oQuL8",
  "headerTwo": "bMKkF oQuL8",
  "headerThree": "zes2I oQuL8",
  "headerFour": "YbFtj oQuL8",
  "headerFive": "EjFMy oQuL8",
  "headerSix": "cjgag oQuL8",
  "child": "_0qvID"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
